import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthorized, getCurrUserData } from "../contexts/CurrUserContext";
import { pageRouteUrls } from "./pageRouteUrls";
import { UserTypeEnum } from "../generated/api";
import { clearAuthRecoveryFlag, tryRecoverAuth } from "./authRecovery";

interface Props {
    children: JSX.Element;
}

const IsAdminRoute = ({ children }: Props) => {
    if (!isAuthorized()) {
        // Looks unauthorized — try one self-healing reload before trusting
        // that (see authRecovery.ts for why this read can be a false negative).
        if (tryRecoverAuth()) return null;
        return <Navigate to={pageRouteUrls.ErrorNotAuth()} replace />;
    }
    clearAuthRecoveryFlag();

    const user = getCurrUserData();
    if (user?.userType !== UserTypeEnum.Admin)
        return <Navigate to={pageRouteUrls.ErrorNotAuth()} replace />;

    return children;
};

export default IsAdminRoute;
